<template>
  <div>
    <!-- 基本信息 -->
    <el-card class="mb-4">
      <template #header>
        <div class="flex items-center">
          <el-icon class="mr-2"><InfoFilled /></el-icon>
          <span>{{ $t('admin.common.basicInfo') }}</span>
        </div>
      </template>

      <el-descriptions :column="2" border>
        <el-descriptions-item v-for="item in basicInfo" :key="item.label" :label="item.label">
          {{ item.value }}
        </el-descriptions-item>
      </el-descriptions>
    </el-card>

    <!-- 权限信息 -->
    <el-card>
      <template #header>
        <div class="flex items-center">
          <el-icon class="mr-2"><Key /></el-icon>
          <span>{{ $t('admin.role.detail.permissionInfo') }}</span>
        </div>
      </template>

      <div class="flex flex-wrap gap-4">
        <el-tag v-for="permission in target?.permissionTexts" :key="permission" type="primary">
          {{ permission }}
        </el-tag>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { InfoFilled, Key } from '@element-plus/icons-vue'

const props = defineProps({
  target: {
    type: Object,
    default: null,
  },
})

// 基本信息描述列表数据
const { t } = useI18n()

const basicInfo = computed(() => {
  if (!props.target) return []

  return [
    {
      label: t('admin.role.detail.labels.roleName'),
      value: props.target.name,
    },
    {
      label: t('admin.role.detail.labels.roleId'),
      value: props.target.code,
    },
    {
      label: t('admin.role.detail.labels.createdAt'),
      value: props.target.created_at,
    },
    {
      label: t('admin.role.detail.labels.updatedAt'),
      value: props.target.updated_at,
    },
    {
      label: t('admin.role.detail.labels.description'),
      value: props.target.remark || '-',
    },
  ]
})
</script>
